var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"chart-data":_vm.verbrauch,"options":_vm.options,"height":400}})}
var staticRenderFns = []

export { render, staticRenderFns }